// ---------------------------------------------------------------------------
// Block Definition: image (DocDsl)
//
// Resolved from source data — no LLM generation needed.  The renderer reads
// the DSL `src` field directly.
// ---------------------------------------------------------------------------

export const imageDef = {
  type: "image",
  label: "Image",
  description: "Image resolved from source data.",

  crystallizer: {
    extractionPhases: [],

    buildDataSchema(block, opts) {
      return { type: "object", additionalProperties: true };
    },

    buildShapeDescription(block) {
      return `{ "src": "<string>" }  // image reference`;
    },

    isBlockLevelTarget() { return false; },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "image",
    category: "media",
    defaultTemplate: { type: "image", src: "" },
  },
};
